import { render, staticRenderFns } from "./EnrollInfo.vue?vue&type=template&id=1d6f7dc5"
import script from "./EnrollInfo.vue?vue&type=script&lang=js"
export * from "./EnrollInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports